export default "__VITE_ASSET__ee5e36c8__"